import classNames from "classnames";
import styles from "./Sharing.module.css";
import { AnimatePresence, motion } from "framer-motion";
import { Facebook, Linkedin, Mail, Twitter } from "react-social-sharing";
import { useCallback, useState } from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import $ from "jquery";
import download from "assets/SVG/Download.svg";
import downloadHovered from "assets/SVG/DownloadHovered.svg";
import share from "assets/SVG/Share.svg";
import { getAssetPath } from "utils";
import { TButtonItemProps } from "types";
import { getLocalAsset } from "utils/getLocalAsset";


export interface SharingProps {
  ButtonSelection: TButtonItemProps[];
  ShowSocialSharing: boolean;
  ShowDownloadIcon: boolean;
  className?: string;
  linkedin?: boolean;
  twitter?: boolean;
  facebook?: boolean;
  email?: boolean;
  copyLink?: boolean;
  DisplaySimplifiedBannerDesktop: boolean;
  ShowQuickFactsSidebar: boolean;
}

export const Sharing = ({
  ShowQuickFactsSidebar,
  ButtonSelection,
  ShowSocialSharing,
  ShowDownloadIcon,
  DisplaySimplifiedBannerDesktop = false,
  linkedin = false,
  twitter = false,
  facebook = false,
  email = false,
  copyLink = false,
  className = "",
  ...props
}: SharingProps) => {
  const [isShown, setIsShown] = useState<boolean>(false);
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const [hovered, setHovered] = useState<boolean>(false);

  const emailSubject = $('title').text();
  const displayDownloadIcon = ShowDownloadIcon && (ButtonSelection.find((v) => v.IsDownloadableFile));
  const downloadFileTarget = ButtonSelection.find((v) => v.Link?.Url?.length);

  const toggleShown = useCallback(() => {
    setIsShown(!isShown)
  }, [isShown]);

  const copyMe = useCallback(() => {
    // toast('Link copied to clipboard', { duration: 2000 })
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  }, []);

  // Open links in new browser window
  const openTarget = useCallback((e: any, l: string) => {
    e.preventDefault()
    window.open(l, '_blank', 'location=yes,height=650,width=500,scrollbars=yes,status=yes')
  }, []);

  // Open emails 
  const openEmail = useCallback((e: any, l: string) => {
    e.preventDefault()
    window.open(l)
  }, []);

  const list = {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
      transition: {
        delay: 2.5
      }
    },
  };

  return (
    <div
      id="social-sharing-container"
      className={classNames(styles.sharing, className, { "slim": !ShowQuickFactsSidebar })} {...props}>
      <div className={classNames(styles.wrapper)}>

        {displayDownloadIcon &&
          <div>
            <button className={styles.download}>
              <a
                rel="noreferrer"
                target={downloadFileTarget?.Link?.Target || "_self"}
                href={getAssetPath(downloadFileTarget?.Link?.Url)}
                download>
                <motion.img
                  whileHover={{ opacity: 0 }}
                  src={getLocalAsset(download)} />
                <motion.img
                  animate={{ zIndex: -1, position: 'absolute', left: 0 }}
                  src={getLocalAsset(downloadHovered)} />
              </a>
            </button>
          </div>
        }

        {ShowSocialSharing &&
          <motion.div
            id="social-menu"
            className={classNames(styles.sharingwrap)}
            onMouseEnter={toggleShown}
            onMouseLeave={toggleShown}
          >
            <button>
              <img src={getLocalAsset(share)} />
            </button>

            <AnimatePresence>
              {isShown && (
                <motion.ul
                  exit="hidden"
                  initial="hidden"
                  animate="visible"
                  variants={list}
                  style={{ pointerEvents: isShown ? "all" : "none" }}
                >
                  <motion.li className={styles.linkedin}>
                    <Linkedin onClick={(e) => openTarget(e, `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`)} label={"Bob"} />
                  </motion.li>
                  <motion.li className={styles.twitter}>
                    <Twitter onClick={(e) => openTarget(e, `https://twitter.com/intent/tweet?url=${window.location.href}`)} label={"Bob"} />
                  </motion.li>
                  <motion.li className={styles.facebook} >
                    <Facebook onClick={(e) => openTarget(e, `https://www.facebook.com/sharer.php?u=${window.location.href}`)} label={"Bob"} />
                  </motion.li>
                  <motion.li className={styles.mail} >
                    <Mail onClick={(e) => openEmail(e, `mailto:?subject=Sent from Aurecon: ${emailSubject}&body=I would like to share this with you: ${window.location.href}`)} label={serviceName => 'Send an email'} />
                  </motion.li>
                  <motion.li className={styles.link}>
                    <CopyToClipboard text={window.location.href} onCopy={copyMe}>
                      <button onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>

                        {isCopied && <div className={styles.tooltipCopy}>
                          Link copied to clipboard!
                        </div>}

                        <AnimatePresence >
                          {!hovered && (
                            <motion.svg
                              style={{ marginLeft: '1px' }}
                              width="25"
                              height="24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m11.97 6.697 1.856-1.856a4.125 4.125 0 1 1 5.833 5.833l-2.651 2.652a4.126 4.126 0 0 1-5.834 0"
                                stroke="#666"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.2"
                              />
                              <path
                                d="m13.03 17.303-1.856 1.857a4.127 4.127 0 0 1-5.835 0 4.124 4.124 0 0 1 .002-5.834l2.651-2.652a4.124 4.124 0 0 1 5.834 0"
                                stroke="#666"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.2"
                              />
                            </motion.svg>
                          )}
                        </AnimatePresence>

                        <AnimatePresence>
                          {hovered && (
                            <motion.svg
                              style={{ marginLeft: '1px' }}
                              width="25"
                              height="24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >

                              <path
                                d="m11.97 6.697 1.856-1.856a4.125 4.125 0 1 1 5.833 5.833l-2.651 2.652a4.126 4.126 0 0 1-5.834 0"
                                stroke="#84BD00"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="m13.03 17.303-1.856 1.857a4.127 4.127 0 0 1-5.835 0 4.124 4.124 0 0 1 .002-5.834l2.651-2.652a4.124 4.124 0 0 1 5.834 0"
                                stroke="#84BD00"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </motion.svg>
                          )}
                        </AnimatePresence>
                      </button>
                    </CopyToClipboard>
                  </motion.li>
                </motion.ul>
              )}
            </AnimatePresence>
          </motion.div>
        }


      </div>
    </div>
  );
};
